// extracted by mini-css-extract-plugin
module.exports = {"heroVideoSection":"_2dFtE","innerContainer":"_3kdsK","title":"_3ixP6","subtitle":"_30ZWs"};